import { useState, useEffect } from 'react';

function getInitialDemoMode(): boolean {
  // Check if window is available (client-side)
  if (typeof window === 'undefined') {
    return false;
  }
  
  try {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('demo') === 'true';
  } catch (error) {
    console.warn('Error parsing URL parameters:', error);
    return false;
  }
}

export function useDemoMode(): boolean {
  const [isDemoMode, setIsDemoMode] = useState(getInitialDemoMode);

  useEffect(() => {
    // Double-check in effect in case the initial value was wrong
    const currentDemoMode = getInitialDemoMode();
    if (currentDemoMode !== isDemoMode) {
      setIsDemoMode(currentDemoMode);
    }
  }, [isDemoMode]);

  return isDemoMode;
}